import { BankLine } from '../../bankReconciliation/types'
import { Voucher } from '../types'

export const getVoucherBankLine = (voucher?: Voucher, bankLines: BankLine[] = []): BankLine | undefined =>
  voucher?.bankLineId ? bankLines.find((bankLine) => bankLine.id === voucher.bankLineId) : undefined
